import React from 'react';
import * as ReactDOM from 'react-dom';
import {post} from '../../utils/request';
import api from './api';
import { ListView } from 'antd-mobile';
import { href } from '../../utils/util';
//添加水印
import watermark from 'watermark-dom';
import cookies from 'js-cookie';
import './index.less';


const NUM_SECTIONS = 10;
const NUM_ROWS_PER_SECTION = 10;
let pageIndex = 0;

let dataBlobs = {};
let sectionIDs = [];
let rowIDs = [];
function genData(pIndex = 0) {
    for (let i = 0; i < NUM_SECTIONS; i++) {
        const ii = (pIndex * NUM_SECTIONS) + i;
        const sectionName = `Section ${ii}`;
        sectionIDs.push(sectionName);
        dataBlobs[sectionName] = sectionName;
        rowIDs[ii] = [];

        for (let jj = 0; jj < NUM_ROWS_PER_SECTION; jj++) {
            const rowName = `S${ii}, R${jj}`;
            rowIDs[ii].push(rowName);
            dataBlobs[rowName] = rowName;
        }
    }
    sectionIDs = [...sectionIDs];
    rowIDs = [...rowIDs];
}


class geelyNotice extends React.Component {
  constructor(props) {
        super(...props);

        const getSectionData = (dataBlob, sectionID) => dataBlob[sectionID];
        const getRowData = (dataBlob, sectionID, rowID) => dataBlob[rowID];
        const dataSource = new ListView.DataSource({
            getRowData,
            getSectionHeaderData: getSectionData,
            rowHasChanged: (row1, row2) => row1 !== row2,
            sectionHeaderHasChanged: (s1, s2) => s1 !== s2,
        });

        this.state = {
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 10 / 4,
            data: [],
            skipCount: 0,
            pageSize: 10,
        }
  }
  componentWillMount() {
    var obj = '',obj1 = '',ops={};
    if(window.location.hash.indexOf('?') > -1 ){
        obj = window.location.hash.split('?')[1];
        obj1 = obj.split('&');
        for(var i=0;i<obj1.length;i++){
            ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
        }
    }
    
    sectionIDs = [];
    rowIDs = [];
    dataBlobs = {};
    pageIndex = 0;
    this.setState({
        urlOps: ops
    },()=>{
      genData();
      this.getQueryNoticeList();
    });
  }

  getQueryNoticeList(type){
    const {skipCount, pageSize} = this.state;

    post({
      url: api.queryNoticeList,
      data:{
        skipCount: skipCount * pageSize,
        pageSize: pageSize
      }
    }).then((res) => {
        // console.log('查询公告列表', res)
        // Toast.info(res.msg,1);
        if(res.result === 'success' && res.data || res.data.length > 0){
          this.setState({
            data: res.data
          },()=>{
            if(sectionIDs.length >= res.count){
              this.setState({
                hasMore: false
              });
            }
            if(type){
              this.setState({
                dataSource: this.state.dataSource.cloneWithRowsAndSections(dataBlobs, sectionIDs, rowIDs),
                isLoading: false,
              });
            }else{
              const hei = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop;
              this.setState({
                dataSource: this.state.dataSource.cloneWithRowsAndSections(dataBlobs, sectionIDs, rowIDs),
                isLoading: false,
                height: hei,
              });
            }
          });
        }else{
          
        }
    }, (res)=>{
        console.log('查询公告列表失败', res)
    });
  }


  onEndReached = (event) => {
        // load new data
        // hasMore: from backend data, indicates whether it is the last page, here is false
        if (this.state.isLoading || !this.state.hasMore) {
            return;
        }
        console.log('reach end', event);
        this.setState({ isLoading: true });
        setTimeout(() => {
            pageIndex++;
            genData(pageIndex);
            this.setState({
                skipCount: pageIndex
            },()=>{
                this.getQueryNoticeList(1)
            });
        }, 1000);
  }

  
  
  render() {
    const {data, urlOps} = this.state;
    // let index = data.length - 1;
    let index = 0;
    const row = (rowData, sectionID, rowID) => {
        let obj = {};
        if(index <= data.length - 1){
            obj = data[index++];
        }else{
            return (<div></div>)
        }
        
        return (
            <div className="item" key={rowID} onClick={()=>{
                href(`/geelyNoticeDetail?id=${obj.contentId}&userName=${decodeURI(urlOps.userName)}&jobCard=${urlOps.jobCard}`);
            }}>
                <h2>
                    <span>{obj.contentAttr}</span>
                    {obj.contentTitle}
                </h2>
                <div className="source">
                    <span>{obj.gmtCreate}</span>
                </div>
            </div>
        );
    };
    
    if(urlOps.userName){
      watermark.load({
        watermark_txt: `${decodeURI(urlOps.userName)}/${urlOps.jobCard}`,
        watermark_x:-15,                     //水印起始位置x轴坐标
        watermark_y:0,                     //水印起始位置Y轴坐标
        watermark_x_space:20,              //水印x轴间隔
        watermark_y_space:70,               //水印y轴间隔
        watermark_color:'#000',//"#001529",
        watermark_fontsize:'12px',
        watermark_width: 110,
        watermark_alpha: 0.15,
        watermark_height: 18,
        // watermark_parent_node:'geelyNoticeBox'
      });
    }

    return (
        <div className="geelyNoticeBox" id="geelyNoticeBox">
            <ListView
                className="am-list"
                ref={el => this.lv = el}
                dataSource={this.state.dataSource}
                renderFooter={() => (<div style={{ padding: 30, textAlign: 'center' }}>
                    {this.state.isLoading ? '加载中...' : '已经到底了！'}
                </div>)}
                renderRow={row}
                style={{
                    height: this.state.height,
                    overflow: 'auto',
                }}
                pageSize={10}
                onScroll={() => { console.log('scroll'); }}
                scrollRenderAheadDistance={500}
                onEndReached={this.onEndReached}
                onEndReachedThreshold={10}
            />
        </div>
    );
  }
}

export default geelyNotice;


// WEBPACK FOOTER //
// ./src/geelyNotice/index/index.js